
import useFast, { getDefaultFilterValue, getFilterValue, getName, getSelectDataByFilterOptions, getFilterCount } from './useFast'
import { getOptions, toggleOption } from './useToggle.js'
import { FieldType } from './enum.js'
import useCascade from './useCascade.js'
import { Message } from 'element-ui';

export default {
	props: {
		gameId: {
			type: Number,
			required: true
		},
		goodsCatalogueId: {
			type: Number,
			required: true
		},
		searchWords: {
			type: String,
			default: ''
		},
		defaultFilterOptions: {
			type: Array,
			default: () => []
		},
		filter: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
            FieldType,
			count: -1, // 筛选结果计数
			filterCountLoading: false,
			// 锚点导航相关数据
			activeAnchorId: null,
			// hooks返回的方法和数据
			anchorMethods: null,
			cascadeMethods: null,
			fastMethods: null,
            showMore: false,

			optListShowMore: {},
			// 一行显示的个数
			showNumber: 6,
            scriptHeight: 'auto',

            filterOptions: []
		}
	},
	watch: {
		/**
		 * 如果真实高度大于显示高度，则显示更多
		 */
		filterOptionsComputed: {
			handler: function (list) {
				if (list.length) {
					this.onSetMoreBtn(list)
				}
			},
			immediate: true,
			deep: true
		},
        defaultFilterOptions: {
            handler: function (list) {
                this.filterOptions = list
            },
            immediate: true,
            deep: true
        }
	},
	computed: {
        filterOptionsFormat() {
            return this.filterOptions?.filter(item => [FieldType.SINGLE, FieldType.LABEL, FieldType.CHECKBOX, FieldType.SINGLE_CASCADE].includes(item.fieldType)) || []
        },
        filterOptionsComputed() {
            if (this.filterOptionsFormat?.length > this.showNumber) {
                return this.showMore ? this.filterOptionsFormat : this.filterOptionsFormat.slice(0, this.showNumber)
            }
            return  this.filterOptionsFormat || []
        },
	},
	mounted() {
		// 初始化hooks
		this.cascadeMethods = useCascade()
		this.fastMethods = useFast(this.filterOptions)
    },
	methods: {
        getName,
        getOptions,
		/**
		 * 全部展开收起
		 */
		onToggleMore() {
			if (this.showMore) {
                window.scrollTo({
                    top: 540,
                    behavior: 'smooth'
                })
			}
			this.showMore = !this.showMore
		},

		updateCount(_count) {
			if (_count) {
				this.count = _count
			}
			else {
				this.refreshCount()
			}
		},
		/**
		 * 右侧显示更多按钮
		 */
		onSetMoreBtn() {
			const itemHeight = 30
			this.$nextTick(() => {
				this.filterOptionsComputed?.forEach((item, index) => {
					const el = this.$refs[`optList${item.id}_${index}`]?.[0]
					this.$set(this.optListShowMore, item.id, el?.scrollHeight > itemHeight)
				})
			})
		},

		/**
		 * 处理全选/取消全选操作
		 * @param category 要操作的分类
		 */
		handleSelectAll(category) {
            const filterCount = getFilterCount(this.filterOptions)
			category.selectAll[category.tabActiveId] = !category.selectAll[category.tabActiveId]
			const o = getOptions(category)

			if (category.selectAll[category.tabActiveId]) {
				// 全选操作：检查数量限制
				const categoryValues = category.value
				if (filterCount + o.options.filter((x) => !categoryValues.some(v => v?.id === x?.id)).length >= 50) {
					category.selectAll[category.tabActiveId] = !category.selectAll[category.tabActiveId]
					return Message.warning('最多只能选择50个筛选条件')
				}
				// 添加所有未选中的选项
				o.options.forEach((item) => {
					if (!categoryValues.some(v => v.id === item.id)) {
						const selectedItem = {
							id: item.id,
							name: item.name,
							nickName: item.nickname
						}
						categoryValues.push(selectedItem)
					}
				})
			}
			else {
				// 取消全选：移除所有选中的选项
				const categoryValues = category.value
				o.options.forEach((item) => {
					const index = categoryValues.findIndex(v => v.id === item.id)
					if (index !== -1) {
						categoryValues.splice(index, 1)
					}
				})
			}

            this.$emit('update:filterOptions', this.filterOptions)
            this.$emit('search')
		},

		/**
		 * 切换选项状态（通用处理）
		 * @param skin 要切换的选项
		 * @param category 所属分类
		 */
		toggleSkin(skin, category) {

			if (category.fieldType === 'SINGLE_CASCADE') {
				// 级联选择类型
				if (this.cascadeMethods && this.cascadeMethods.handleCascadeSelect) {
					this.cascadeMethods.handleCascadeSelect(skin, category, this.filterOptions)
				}
			}
			else {
				// 普通选择类型
				toggleOption(skin, category, this.filterOptions)
			}
			if (category.fieldType !== 'CHECKBOX') {
				// this.refreshCount()
			}

            this.$emit('update:filterOptions', this.filterOptions)

            this.$emit('search')
		},

		/**
		 * 设置筛选模式（全都要有/有1个就行）
		 * @param category 分类对象
		 * @param mode 筛选模式
		 */
		setFilterMode(category, mode) {
	        // console.log('setFilterMode', category, mode)
            if (category.filterMode?.[category.tabActiveId]) {
                category.filterMode[category.tabActiveId] = mode
            } else {
                this.$set(category.filterMode, category.tabActiveId, mode)
            }

            this.$emit('update:filterOptions', this.filterOptions)
            this.$emit('search')
		},

		/**
		 * 切换标签页
		 * @param tab 要切换到的标签
		 * @param category 所属分类
		 */
		switchTab(tab, category) {
			category.tabActiveId = tab.id

            this.$emit('update:filterOptions', this.filterOptions)
            this.$emit('search')
		},

		/**
		 * 切换展开/收起状态
		 * @param options 选项对象
		 */
		toggleExpand(options) {
            this.$set(options, 'expand', !options.expand)
            this.$emit('update:filterOptions', this.filterOptions)
		},

		/**
		 * 检查分类是否有设置值
		 * @param category 分类对象
		 * @returns 是否有设置值
		 */
		getHasSet(category) {
			if (category.fieldType === 'SECTION') {
				// 区间类型：检查是否有最小值或最大值
				return (category.value && category.value.min) || (category.value && category.value.max)
			}
			// 其他类型：检查数组是否有内容
			const values = category.value
			return values && values.length > 0
		},

		/**
		 * 滚动到锚点
		 */
		scrollToAnchor(anchorId) {
			if (this.anchorMethods && this.anchorMethods.scrollToAnchor) {
				this.anchorMethods.scrollToAnchor(anchorId)
			}
		},

		/**
		 * 处理滚动事件
		 */
		handleScroll(event) {
			if (this.anchorMethods && this.anchorMethods.handleScroll) {
				this.anchorMethods.handleScroll(event)
			}
		},

		/**
		 * 检查锚点是否激活
		 */
		isActiveAnchor(anchorId) {
			if (this.anchorMethods && this.anchorMethods.isActiveAnchor) {
				return this.anchorMethods.isActiveAnchor(anchorId)
			}
			return false
		},

		/**
		 * 获取级联选项
		 */
		getCascadeOptions(category, level) {
			if (this.cascadeMethods && this.cascadeMethods.getCascadeOptions) {
				return this.cascadeMethods.getCascadeOptions(category, level)
			}
			return []
		},

		/**
		 * 检查级联选项是否选中
		 */
		isCascadeOptionSelected(option, category, level) {
			if (this.cascadeMethods && this.cascadeMethods.isCascadeOptionSelected) {
				return this.cascadeMethods.isCascadeOptionSelected(option, category, level)
			}
			return false
		}

	}
}
